// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetPackageOrderResponse

export type WidgetPackageOrderApiResponse = {
	id: string;
	amount: number;
	discountAmount: number | null;
	discountCode: string | null;
};

export type WidgetPackageOrder = {
	id: string;
	amount: number;
	discountAmount: number | null;
	discountCode: string | null;
};

export function hydrateWidgetPackageOrder(data: WidgetPackageOrderApiResponse): WidgetPackageOrder {
	return { ...data };
}